'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiKeyOutline = function TiKeyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.7 35h-10v-7.4l6.3-6.3c-0.3-0.9-0.5-1.9-0.5-3 0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10h-2.5v3.4h-3.3v3.3z m-6.7-3.3h3.3v-3.4h3.4v-3.3h5.8c3.7 0 6.7-3 6.7-6.7s-3-6.6-6.7-6.6-6.7 3-6.7 6.6c0 1 0.2 1.9 0.6 2.8l0.5 1-6.9 6.9v2.7z m12.5-15c0.9 0 1.7 0.7 1.7 1.6 0 1-0.8 1.7-1.7 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.8-1.6 1.7-1.6z m0-1.7c-1.8 0-3.3 1.5-3.3 3.3 0 1.9 1.5 3.4 3.3 3.4 1.8 0 3.3-1.5 3.3-3.4 0-1.8-1.5-3.3-3.3-3.3z' })
        )
    );
};

exports.default = TiKeyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/key-outline.js
// module id = 2093
// module chunks = 0